import React from 'react'
import WarningCard from '../../pages/CreateRequestStepper.js/components/WarningCard'
import useScreen from '../../hooks/useScreen'
import PropTypes from 'prop-types'

const PendingMessage = ({ bottom }) => {
    const { isMobile, isTablet } = useScreen()
    return (
        <div
            className={`fixed right-0 p-0 z-50 ${
                isMobile || isTablet
                    ? `bottom-${
                          typeof bottom !== 'undefined' ? bottom : 24
                      } w-full`
                    : `bottom-0 w-96`
            }`}
        >
            <WarningCard
                error={
                    <>
                        Your request is pending.
                        <br />
                        It will be synced once you&apos;re back online.
                    </>
                }
            />
        </div>
    )
}

PendingMessage.propTypes = {
    bottom: PropTypes.number,
}

export default PendingMessage
